import React from "react"
import {BenefitHeader} from "@irati-web/benefits/components/benefitHeader"
import {BenefitCardInfo} from "@irati-web/benefits/components/benefitCardInfo"
import {Grid} from "react-bootstrap"
import theme from "@irati/ui/src/global/theme"
import UsersCheck from "@irati/ui/images/users_check.svg"
import EyeGlassesTwo from "@irati/ui/images/eyeglasses_2.svg"

import {IconTypes} from "@irati/ui/src/Icon"
import {BenefitSteps} from "@irati-web/benefits/components/benefitSteps"
import {BenefitFAQ} from "@irati-web/benefits/components/benefitFAQ"
import {BenefitTilesCard} from "@irati-web/benefits/components/benefitTilesCard"

export const HealthCashLandingScreen = () => {
  return (
    <>
      <Grid>
        <BenefitHeader
          secondCtaUrl="/health_cash_plan/landing"
          secondCtaTitle="healthCashPlan.landing.header.rightCta.title"
          firstCtaTitle="healthCashPlan.landing.header.leftCta.title"
          firstCtaUrl="/health_cash_plan/landing"
          title="platform.products.healthCashPlan.title"
        />
        <BenefitCardInfo
          title="healthCashPlan.landing.sectionOne.title"
          imagePosition="right"
          imageSrc="healthCashPlan.landing.sectionOne.imageRight.src"
          hint="healthCashPlan.landing.sectionOne.hint"
          tilesData={tilesDataOne}
        />
      </Grid>
      <BenefitSteps title="healthCashPlan.landing.steps.start.title" items={steps} itemsPerRow={3} />
      <Grid>
        <BenefitTilesCard
          leftCtaText="healthCashPlan.landing.sectionTwo.leftCta.title"
          leftCtaUrl="/health_cash_plan/landing"
          rightCtaText="healthCashPlan.landing.sectionTwo.rightCta.title"
          rightCtaUrl="/health_cash_plan/landing"
          title="healthCashPlan.landing.sectionTwo.title"
          additionalInfoText="healthCashPlan.landing.sectionTwo.additionalInfo"
          tilesDataTwo={tilesDataTwo}
        />
        <BenefitFAQ
          title="healthCashPlan.landing.faq.title"
          faqCtaText="healthCashPlan.landing.faq.accessCTA"
          subtitle="healthCashPlan.landing.faq.subtitle"
          faqCtaUrl="/health_cash_plan/landing"
        />
      </Grid>
    </>
  )
}

const tilesDataOne = [
  {
    description: "healthCashPlan.landing.sectionOne.tile.titleOne",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.healthAndSafety
  },
  {
    description: "healthCashPlan.landing.sectionOne.tile.titleTwo",
    iconBgColor: theme.colors.tertiary.s2_400,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.medicalServices
  },
  {
    description: "healthCashPlan.landing.sectionOne.tile.titleThree",
    iconBgColor: theme.colors.tertiary.b_300,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.emergency911
  },
  {
    description: "healthCashPlan.landing.sectionOne.tile.titleFour",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    icon: UsersCheck
  }
]

const steps = [
  {
    title: "healthCashPlan.landing.steps.stepOne.title",
    subTitle: "healthCashPlan.landing.steps.stepOne.subtitle",
    image: "healthCashPlan.landing.steps.stepOne.image.src"
  },
  {
    title: "healthCashPlan.landing.steps.stepTwo.title",
    subTitle: "healthCashPlan.landing.steps.stepTwo.subtitle",
    image: "healthCashPlan.landing.steps.stepTwo.image.src"
  },
  {
    title: "healthCashPlan.landing.steps.stepThree.title",
    subTitle: "healthCashPlan.landing.steps.stepThree.subtitle",
    image: "healthCashPlan.landing.steps.stepThree.image.src"
  }
]

const tilesDataTwo = [
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleOne",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.dentistry,
    category: "left"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleTwo",
    iconBgColor: theme.colors.tertiary.s2_400,
    iconColor: theme.colors.greys.white,
    icon: EyeGlassesTwo,
    category: "left"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleThree",
    iconBgColor: theme.colors.tertiary.b_300,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.rheumatology,
    category: "left"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleFour",
    iconBgColor: theme.colors.tertiary.p_200,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.homeHealth,
    category: "left"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleFive",
    iconBgColor: theme.colors.tertiary.o_200,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.physicalTherapy,
    category: "left"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleSix",
    iconBgColor: theme.colors.tertiary.r_200,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.healthAndSafety,
    category: "right"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleSeven",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.medicalServices,
    category: "right"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleEight",
    iconBgColor: theme.colors.tertiary.y_400,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.emergency911,
    category: "right"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleNine",
    iconBgColor: theme.colors.tertiary.o_400,
    iconColor: theme.colors.greys.white,
    icon: UsersCheck,
    category: "right"
  },
  {
    description: "healthCashPlan.landing.sectionTwo.tile.titleTen",
    category: "right"
  }
]
